import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@reach/router';

const getWebPagesInArr = (arr, result) => {
  // Function used to handle Rare Disease Table pagination metadata-ld
  const output = result ?? [];
  arr.forEach((obj) => {
    if (obj[`@type`] === `WebPage`) {
      output.push(obj);
    }
    Object.values(obj).forEach((subArr) => {
      if (!Array.isArray(subArr)) {
        return;
      }
      getWebPagesInArr(subArr, output);
    });
  });
  return output;
};

const useMetadataLd = () => {
  const location = useLocation();
  const pathname = location.pathname.slice(1).replace(/\/$/, ``) || `index`;
  const metadataLd = useStaticQuery(
    graphql`
      query {
        allFile(
          filter: { relativeDirectory: { regex: "/^_content/metatags-ld/" } }
        ) {
          edges {
            node {
              childrenJsonData {
                childMetadataLd {
                  metadataLd
                }
              }
              relativePath
            }
          }
        }
      }
    `
  );

  let path = `_content/metatags-ld/${pathname}.json`;

  if (pathname.slice(0, 9) === `dna-apps/`) {
    path = `_content/metatags-ld/${pathname
      .split(`/`)
      .slice(0, 2)
      .join(`/`)}.json`;
  }

  if (pathname.slice(0, 9) === `dna-apps/`) {
    path = `_content/metatags-ld/${pathname
      .split(`/`)
      .slice(0, 2)
      .join(`/`)}.json`;
  }

  if (pathname.slice(0, 30) === `rare-disease-dna-analysis-list`) {
    // We're using custom Gatsby plugin to handle metadata-ld we need to parse
    // content from graphQL query then modify it and again stringify to map metadata-ld scripts
    path = `_content/metatags-ld/rare-disease-dna-analysis-list.json`;
    const requiredJson = metadataLd.allFile.edges
      .find((edge) => edge.node.relativePath === path)
      .node.childrenJsonData.map((data) =>
        JSON.parse(data.childMetadataLd.metadataLd)
      );
    const currentPage = pathname.split(`/`).pop();
    if (currentPage) {
      const clone = JSON.parse(JSON.stringify(requiredJson));
      getWebPagesInArr(clone).forEach((webPage) => {
        webPage.name = `${webPage.name} | Page - ${currentPage}`;
        webPage.url = `${webPage.url}/${currentPage}`;
        webPage[`@id`] = `${webPage[`@id`]}/${currentPage}`;
      });

      const preparedClonedData = clone.map((item) => JSON.stringify(item));

      return preparedClonedData;
    }
  }

  const pageMetadataLD = metadataLd.allFile.edges.find(
    (edge) => edge.node.relativePath === path
  );

  const pageMetadataLdArray = pageMetadataLD
    ? pageMetadataLD.node.childrenJsonData.map(
        (item) => item.childMetadataLd.metadataLd
      )
    : [];

  return pageMetadataLdArray;
};

export default useMetadataLd;
